import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-configuration',
  templateUrl: './header-configuration.component.html',
  styleUrls: ['./header-configuration.component.scss'],
})
export class HeaderConfigurationComponent {
  @Input() title: string = '';
  @Input() description: string = '';
}
